window.fox = {};
window.fox.settings = {};

// IDと名称のマップ
window.fox.settings.model = {

//Apple iPhone
  AP2279: 'iPhone 17',
  AP2280: 'iPhone 17 Pro',
  AP2281: 'iPhone Air',
  AP2282: 'iPhone 17 Pro Max',

  AP2267: 'iPhone 16e',
  AP2251: 'iPhone 16',
  AP2252: 'iPhone 16 Pro',
  AP2253: 'iPhone 16 Plus',
  AP2254: 'iPhone 16 Pro Max',
  AP2221: 'iPhone 15',
  AP2223: 'iPhone 15 Pro',
  AP2222: 'iPhone 15 Plus',
  AP2224: 'iPhone 15 Pro Max',
  AP2179: 'iPhone 14',
  AP2181: 'iPhone 14 Pro',
  AP2180: 'iPhone 14 Plus',
  AP2182: 'iPhone 14 Pro Max',
  AP2111: 'iPhone 13',
  AP2112: 'iPhone 13 Pro',
  AP2110: 'iPhone 13 mini',
  AP2113: 'iPhone 13 Pro Max',
  AP2107: 'iPhone 12',
  AP2108: 'iPhone 12 Pro',
  AP2106: 'iPhone 12 mini',
  AP2109: 'iPhone 12 Pro Max',
  AP2145: 'iPhone SE 3rd Generation',
  AP2114: 'iPhone SE 2nd Generation',
  AP2105: 'iPhone 11',
  AP2144: 'iPhone 11 Pro',
  AP2200: 'iPhone 11 Pro Max',
  AP2104: 'iPhone XR',
  AP2131: 'iPhone XS',
  AP2199: 'iPhone XS Max',
  AP2130: 'iPhone X',
  AP2127: 'iPhone 8',
  AP2198: 'iPhone 8 Plus',
  AP2126: 'iPhone 7',
  AP2197: 'iPhone 7 Plus',
  AP2196: 'iPhone 6s Plus',


//Galaxy
  SS2268: 'Galaxy S25',
  SS2269: 'Galaxy S25 Ultra',
  SS2238: 'Galaxy S24',
  SS2239: 'Galaxy S24 Ultra',
  SS2237: 'Galaxy S23 FE',
  SS2211: 'Galaxy S23',
  SS2212: 'Galaxy S23 Ultra',
  SS2147: 'Galaxy S22',
  SS2161: 'Galaxy S22 Ultra',
  SS2103: 'Galaxy S21 5G',
  SS2162: 'Galaxy S21+ 5G',
  SS2207: 'Galaxy S21 Ultra 5G',
  SS2135: 'Galaxy S20',
  SS2205: 'Galaxy S20+',
  SS2206: 'Galaxy S20 Ultra',
  SS2146: 'Galaxy S10',
  SS2204: 'Galaxy S10+',
  SS2209: 'Galaxy S9',
  SS2202: 'Galaxy S9+',
  
  SS2286: 'Galaxy Z Flip7',
  SS2257: 'Galaxy Z Flip6',
  SS2226: 'Galaxy Z Flip5',
  SS2287: 'Galaxy Z Fold7',
  SS2258: 'Galaxy Z Fold6',
  SS2227: 'Galaxy Z Fold5',
  
  SS2248: 'Galaxy A55',
  SS2216: 'Galaxy A54 5G',
  SS2175: 'Galaxy A53 5G',
  SS2203: 'Galaxy A52 5G',
  SS2164: 'Galaxy A32 5G',
  SS2271: 'Galaxy A25 5G',
  SS2192: 'Galaxy A23 5G',
  
  SS2193: 'Galaxy Buds Pro',


  //Google Pixel
  GG2288: 'Pixel 10',
  GG2289: 'Pixel 10 Pro',
  GG2290: 'Pixel 10 Pro XL',
  GG2270: 'Pixel 9a',
  GG2255: 'Pixel 9',
  GG2256: 'Pixel 9 Pro',
  GG2259: 'Pixel 9 Pro XL',
  GG2235: 'Pixel 8a',
  GG2218: 'Pixel 8',
  GG2219: 'Pixel 8 Pro',
  GG2213: 'Pixel 7a',
  GG2183: 'Pixel 7',
  GG2184: 'Pixel 7 Pro',
  GG2178: 'Pixel 6a',
  GG2132: 'Pixel 6',
  GG2133: 'Pixel 6 Pro',
  GG2120: 'Pixel 5',
  GG2138: 'Pixel 5a 5G',

  GG2260: 'Pixel Fold 2',
  GG2217: 'Pixel Fold',

  //Xiaomi
  XM2275: 'Xiaomi 14T',
  XM2276: 'Xiaomi 14T Pro',
  XM2232: 'Xiaomi 13T',
  XM2233: 'Xiaomi 13T Pro',
  XM2210: 'Xiaomi 12T Pro',
  XM2136: 'Xiaomi 11T',
  XM2137: 'Xiaomi 11T Pro',
  XM2266: 'Xiaomi Redmi 12C',
  XM2140: 'Xiaomi Mi 11 Lite 5G',
  XM2249: 'Redmi Note 13 Pro 5G',
  XM2250: 'Redmi Note 13 Pro+ 5G',
  XM2189: 'Redmi Note 11',
  XM2190: 'Redmi Note 11 Pro',
  XM2122: 'Redmi Note 10 Pro',
  XM2169: 'Redmi Note10 JE',
  XM2231: 'Redmi 12 5G',
  XM2121: 'Redmi 9T',

//SONY Xperia
  SN2246: 'Xperia 1 VI',
  SN2214: 'Xperia 1 V',
  SN2165: 'Xperia 1 IV',
  SN2172: 'Xperia 1 III',
  SN2141: 'Xperia 1 II',

  SN2225: 'Xperia 5 V',
  SN2194: 'Xperia 5 IV',
  SN2151: 'Xperia 5 III',
  SN2123: 'Xperia 5 II',
  SN2142: 'Xperia 5',

  SN2247: 'Xperia 10 VI',
  SN2215: 'Xperia 10 V',
  SN2166: 'Xperia 10 IV',
  SN2125: 'Xperia 10 III',
  SN2143: 'Xperia 10 II',

  SN2167: 'Xperia Ace III',
  
//Motorola
  MT2306: 'Motorola edge 60 pro',
  MT2265: 'Motorola edge 50 pro',
  MT2264: 'Motorola edge 40 neo',
  MT2263: 'Motorola edge 40',
  MT2186: 'Motorola edge 30 PRO',
  MT2139: 'Motorola edge 20',

  MT2305: 'Motorola razr 60',

  MT2116: 'Motorola moto g100',
  MT2129: 'Motorola moto g50 5G',

  MT2187: 'Motorola moto g31',
  MT2201: 'Motorola moto g30',

//OPPO
  OP2262: 'OPPO Reno9 A',
  OP2188: 'OPPO Reno7 A',
  OP2134: 'OPPO A54 5G',
  OP2153: 'OPPO A55s 5G',
  OP2163: 'OPPO Find X3 Pro',
  
//SHARP AQUOS
  SH2285: 'AQUOS R10',
  SH2291: 'AQUOS R9',
  SH2292: 'AQUOS R9 Pro',

  SH2284: 'AQUOS wish5',
  SH2294: 'AQUOS wish4',
  SH2293: 'AQUOS wish3',
  SH2177: 'AQUOS wish2',
  SH2149: 'AQUOS wish',

  SH2310: 'AQUOS sense10',
  SH2296: 'AQUOS sense9',
  SH2295: 'AQUOS sense8',
  SH2185: 'AQUOS sense7',
  SH2165: 'AQUOS sense6s',
  SH2148: 'AQUOS sense6',
  SH2170: 'AQUOS sense5G',
  SH2171: 'AQUOS sense3 basic',

  SH2168: 'AQUOS zero6',

//HUAWEI
  HW2117: 'HUAWEI P30 lite',

//arrows
    FC2150: 'arrows We',

//ZTE
  // ZT2234: 'Libero Flip',



//アクセサリー
  n000: 'Accessory',
  AP2154: 'AirPods 1st Generation',
  AP2155: 'AirPods 2nd Generation',
  AP2156: 'AirPods 3rd Generation',
  AP2157: 'AirPods Pro',
  AP2158: 'Apple Watch（38mm～41mm）',
  AP2159: 'Apple Watch（42mm～45mm）',

//スマホショルダータグ
  NKSTGY: 'Smartphone shoulder strap (thin) [ GRAY ]',
  NKSTBKGD: 'Smartphone shoulder strap (thin) [ BLACK + GOLD ]',
  NKSTNVGD: 'Smartphone shoulder strap (thin) [ NAVY + GOLD ]',
  BNKSTBK: 'Smartphone shoulder strap (thick) [ BLACK ]',
  BNKSTBE: 'Smartphone shoulder strap (thick) [ BEIGE ]',
  BNKSTDPGY: 'Smartphone shoulder strap (thick) [ DEEPGRAY ]',
  HDSTGY: 'Smartphone hand strap (thin) [ GRAY ]',
  HDSTBKGD: 'Smartphone hand strap (thin) [ BLACK + GOLD ]',
  HDSTNVGD: 'Smartphone hand strap (thin) [ NAVY + GOLD ]',

//PCケース
  // NC2261: 'LAVIE SOL',
};

// 機種判定マスター
window.fox.settings.android_uas = {
    'OPPO A73': 'OP2101',
    'Galaxy A51 5G': 'SS2102',
    'Galaxy S21 5G': 'SS2103',
    'moto e7': 'MT2115',
    'moto g100': 'MT2116',
    'HUAWEI P30 lite': 'HW2117',
    'Google Pixel 4a': 'GG2118',
    'Google Pixel 4a 5G': 'GG2119',
    'Google Pixel 5': 'GG2120',
    'Redmi 9T': 'XM2121',
    'Redmi Note 10 Pro': 'XM2122',
    'SONY Xperia 5 II': 'SN2123',
    'SONY Xperia 1 III': 'SN2124',
    'SONY Xperia 10 III': 'SN2125',
};

//あなたのスマホを選択（画面右下）
window.fox.settings.model_groups = [
  {
    label: 'Apple',
    code: 'AP',
    slug: 'series-iPhone',
    code_sort: [
      'AP2279', /*iPhone 17*/
      'AP2280', /*iPhone 17 Pro*/
      'AP2281', /*iPhone Air*/
      'AP2282', /*iPhone 17 Pro Max*/
      'AP2267', /*iPhone 16e*/
      'AP2251', /*iPhone 16*/
      'AP2252', /*iPhone 16 Pro*/
      'AP2253', /*iPhone 16 Plus*/
      'AP2254', /*iPhone 16 Pro Max*/
      'AP2221', /*iPhone 15*/
      'AP2223', /*iPhone 15 Pro*/
      'AP2222', /*iPhone 15 Plus*/
      'AP2224', /*iPhone 15 Pro Max*/
      'AP2179', /*iPhone 14*/
      'AP2181', /*iPhone 14 Pro*/
      'AP2180', /*iPhone 14 Plus*/
      'AP2182', /*iPhone 14 Pro Max*/
      'AP2111', /*iPhone 13*/
      'AP2112', /*iPhone 13 Pro*/
      'AP2110', /*iPhone 13 mini*/
      'AP2113', /*iPhone 13 Pro Max*/
      'AP2107', /*iPhone 12*/
      'AP2108', /*iPhone 12 Pro*/
      'AP2106', /*iPhone 12 mini*/
      'AP2109', /*iPhone 12 Pro Max*/
      'AP2145', /*iPhone SE 3rd Generation*/
      'AP2114', /*iPhone SE 2nd Generation*/
      'AP2105', /*iPhone 11*/
      'AP2144', /*iPhone 11 Pro*/
      'AP2200', /*iPhone 11 Pro Max*/
      'AP2104', /*iPhone XR*/
      'AP2131', /*iPhone XS*/
      'AP2199', /*iPhone XS Max*/
      'AP2130', /*iPhone X*/
      'AP2127', /*iPhone 8*/
      'AP2198', /*iPhone 8 Plus*/
      'AP2126', /*iPhone 7*/
      'AP2197', /*iPhone 7 Plus*/
      'AP2196', /*iPhone 6s Plus*/
    ]
  },
    {
    label: 'Samsung',
    code: 'SS',
    slug: 'series-galaxy',
    code_sort: [
      'SS2268', /*Galaxy S25*/
      'SS2269', /*Galaxy S25 Ultra*/
      'SS2238', /*Galaxy S24*/
      'SS2239', /*Galaxy S24 Ultra*/
      'SS2237', /*Galaxy S23 FE*/
      'SS2211', /*Galaxy S23*/
      'SS2212', /*Galaxy S23 Ultra*/
      'SS2147', /*Galaxy S22*/
      'SS2161', /*Galaxy S22 Ultra*/
      'SS2103', /*Galaxy S21 5G*/
      'SS2162', /*Galaxy S21+ 5G*/
      'SS2207', /*Galaxy S21 Ultra 5G*/
      'SS2135', /*Galaxy S20*/
      'SS2205', /*Galaxy S20+*/
      'SS2206', /*Galaxy S20 Ultra*/
      'SS2146', /*Galaxy S10*/
      'SS2204', /*Galaxy S10+*/
      'SS2209', /*Galaxy S9*/
      'SS2202', /*Galaxy S9+*/
      
      'SS2286', /*Galaxy Z Flip7*/
      'SS2257', /*Galaxy Z Flip6*/
      'SS2226', /*Galaxy Z Flip5*/
      'SS2287', /*Galaxy Z Fold7*/
      'SS2258', /*Galaxy Z Fold6*/
      'SS2227', /*Galaxy Z Fold5*/
      
      'SS2248', /*Galaxy A55*/
      'SS2216', /*Galaxy A54 5G*/
      'SS2175', /*Galaxy A53 5G*/
      'SS2203', /*Galaxy A52 5G*/
      'SS2164', /*Galaxy A32 5G*/
      'SS2271', /*Galaxy A25 5G*/
      'SS2192', /*Galaxy A23 5G*/
      
      'SS2193', /*Galaxy Buds Pro*/
    ]
  },
  {
    label: 'Google',
    code: 'GG',
    slug: 'series-google-Pixel',
    code_sort: [
      'GG2288', /*Pixel 10*/
      'GG2289', /*Pixel 10 Pro*/
      'GG2290', /*Pixel 10 Pro XL*/
      'GG2270', /*Pixel 9a*/
      'GG2255', /*Pixel 9*/
      'GG2256', /*Pixel 9 Pro*/
      'GG2259', /*Pixel 9 Pro XL*/
      'GG2235', /*Pixel 8a*/
      'GG2218', /*Pixel 8*/
      'GG2219', /*Pixel 8 Pro*/
      'GG2213', /*Pixel 7a*/
      'GG2183', /*Pixel 7*/
      'GG2184', /*Pixel 7 Pro*/
      'GG2178', /*Pixel 6a*/
      'GG2132', /*Pixel 6*/
      'GG2133', /*Pixel 6 Pro*/
      'GG2120', /*Pixel 5*/
      'GG2138', /*Pixel 5a 5G*/

      'GG2260', /*Pixel Fold 2*/
      'GG2217', /*Pixel Fold*/
    ]
  },
  {
    label: 'Xiaomi',
    code: 'XM',
    slug: '',
    code_sort: [
      'XM2275', /*Xiaomi 14T*/
      'XM2276', /*Xiaomi 14T Pro*/
      'XM2232', /*Xiaomi 13T*/
      'XM2233', /*Xiaomi 13T Pro*/
      'XM2210', /*Xiaomi 12T Pro*/
      'XM2136', /*Xiaomi 11T*/
      'XM2137', /*Xiaomi 11T Pro*/
      'XM2266', /*Xiaomi Redmi 12C*/
      'XM2140', /*Xiaomi Mi 11 Lite 5G*/
      
      'XM2249', /*Redmi Note 13 Pro 5G*/
      'XM2250', /*Redmi Note 13 Pro+ 5G*/
      'XM2189', /*Redmi Note 11*/
      'XM2190', /*Redmi Note 11 Pro*/
      'XM2122', /*Redmi Note 10 Pro*/
      'XM2169', /*Redmi Note10 JE*/
      'XM2231', /*Redmi 12 5G*/
      'XM2121', /*Redmi 9T*/
    ]
  },
  {
    label: 'Sony',
    code: 'SN',
    slug: 'series-Xperia',
    code_sort: [
      'SN2246', /*Xperia 1 VI*/
      'SN2214', /*Xperia 1 V*/
      'SN2165', /*Xperia 1 IV*/
      'SN2172', /*Xperia 1 III*/
      'SN2141', /*Xperia 1 II*/

      'SN2225', /*Xperia 5 V*/
      'SN2194', /*Xperia 5 IV*/
      'SN2151', /*Xperia 5 III*/
      'SN2123', /*Xperia 5 II*/
      'SN2142', /*Xperia 5*/

      'SN2247', /*Xperia 10 VI*/
      'SN2215', /*Xperia 10 V*/
      'SN2166', /*Xperia 10 IV*/
      'SN2125', /*Xperia 10 III*/
      'SN2143', /*Xperia 10 II*/

      'SN2167', /*Xperia Ace III*/
    ]
  },
  {
    label: 'Motorola',
    code: 'MT',
    slug: '',
    code_sort: [
     'MT2306', /*Motorola edge 60 pro*/
      'MT2265', /*Motorola edge 50 pro*/
      'MT2264', /*Motorola edge 40 neo*/
      'MT2263', /*Motorola edge 40*/
      'MT2186', /*Motorola edge 30 PRO*/
      'MT2139', /*Motorola edge 20*/

      'MT2305', /*Motorola razr 60*/

      'MT2116', /*Motorola moto g100*/
      'MT2129', /*Motorola moto g50 5G*/

      'MT2187', /*Motorola moto g31*/
      'MT2201', /*Motorola moto g30*/
    ]
  },
  {
    label: 'OPPO',
    code: 'OP',
    slug: '',
    code_sort: [
      'OP2262', /*'OPPO Reno9 A*/
      'OP2188', /*'OPPO Reno7 A*/
      'OP2134', /*'OPPO A54 5G*/
      'OP2153', /*'OPPO A55s 5G*/
      'OP2163', /*'OPPO Find X3 Pro*/
    ]
  },
  {
    label: 'SHARP',
    code: 'SH',
    slug: 'series-AQUOS',
    code_sort: [
      'SH2285', /*AQUOS R10*/
      'SH2291', /*AQUOS R9*/
      'SH2292', /*AQUOS R9 Pro*/

      'SH2284', /*AQUOS wish5*/
      'SH2294', /*AQUOS wish4*/
      'SH2293', /*AQUOS wish3*/
      'SH2177', /*AQUOS wish2*/
      'SH2149', /*AQUOS wish*/

      'SH2310', /*AQUOS sense10*/
      'SH2296', /*AQUOS sense9*/
      'SH2295', /*AQUOS sense8*/
      'SH2185', /*AQUOS sense7*/
      'SH2165', /*AQUOS sense6s*/
      'SH2148', /*AQUOS sense6*/
      'SH2170', /*AQUOS sense5G*/
      'SH2171', /*AQUOS sense3 basic*/

      'SH2168', /*AQUOS zero6*/
    ]
  },
  {
    label: 'HUAWEI',
    code: 'HW',
    slug: 'series-hw',
    code_sort: [
        'HW2117', /*HUAWEI P30 lite*/
    ]
  },
  {
    label: 'FCNT',
    code: 'FC',
    slug: 'series-arrows',
    code_sort: [
      'FC2150', /*arrows We*/
    ]
  }
  // {
  //   label: 'ZTE',
  //   code: 'ZT',
  //   slug: 'series-zte',
  //   code_sort: [
  // ZT2234', *Libero Flip*/
  //   ]
  // },
  
];

//チェックボックス表示（カラム左　対応機種）
window.fox.settings.model_groups_checkbox = [
  {
    label: 'iPhone',
    code: 'AP',
    slug: 'series-iPhone',
    code_sort: [
      'AP2279', /*iPhone 17*/
      'AP2280', /*iPhone 17 Pro*/
      'AP2281', /*iPhone Air*/
      'AP2282', /*iPhone 17 Pro Max*/
      'AP2267', /*iPhone 16e*/
      'AP2251', /*iPhone 16*/
      'AP2252', /*iPhone 16 Pro*/
      'AP2253', /*iPhone 16 Plus*/
      'AP2254', /*iPhone 16 Pro Max*/
      'AP2221', /*iPhone 15*/
      'AP2223', /*iPhone 15 Pro*/
      'AP2222', /*iPhone 15 Plus*/
      'AP2224', /*iPhone 15 Pro Max*/
      'AP2179', /*iPhone 14*/
      'AP2181', /*iPhone 14 Pro*/
      'AP2180', /*iPhone 14 Plus*/
      'AP2182', /*iPhone 14 Pro Max*/
      'AP2111', /*iPhone 13*/
      'AP2112', /*iPhone 13 Pro*/
      'AP2110', /*iPhone 13 mini*/
      'AP2113', /*iPhone 13 Pro Max*/
      'AP2107', /*iPhone 12*/
      'AP2108', /*iPhone 12 Pro*/
      'AP2106', /*iPhone 12 mini*/
      'AP2109', /*iPhone 12 Pro Max*/
      'AP2145', /*iPhone SE 3rd Generation*/
      'AP2114', /*iPhone SE 2nd Generation*/
      'AP2105', /*iPhone 11*/
      'AP2144', /*iPhone 11 Pro*/
      'AP2200', /*iPhone 11 Pro Max*/
      'AP2104', /*iPhone XR*/
      'AP2131', /*iPhone XS*/
      'AP2199', /*iPhone XS Max*/
      'AP2130', /*iPhone X*/
      'AP2127', /*iPhone 8*/
      'AP2198', /*iPhone 8 Plus*/
      'AP2126', /*iPhone 7*/
      'AP2197', /*iPhone 7 Plus*/
      'AP2196', /*iPhone 6s Plus*/
    ]
  },
  {
    label: 'Android',
    code: '',
    slug: 'series-android',
    code_sort: [
    //Galaxyシリーズ
      'SS2268', /*Galaxy S25*/
      'SS2269', /*Galaxy S25 Ultra*/
      'SS2238', /*Galaxy S24*/
      'SS2239', /*Galaxy S24 Ultra*/
      'SS2237', /*Galaxy S23 FE*/
      'SS2211', /*Galaxy S23*/
      'SS2212', /*Galaxy S23 Ultra*/
      'SS2147', /*Galaxy S22*/
      'SS2161', /*Galaxy S22 Ultra*/
      'SS2103', /*Galaxy S21 5G*/
      'SS2162', /*Galaxy S21+ 5G*/
      'SS2207', /*Galaxy S21 Ultra 5G*/
      'SS2135', /*Galaxy S20*/
      'SS2205', /*Galaxy S20+*/
      'SS2206', /*Galaxy S20 Ultra*/
      'SS2146', /*Galaxy S10*/
      'SS2204', /*Galaxy S10+*/
      'SS2209', /*Galaxy S9*/
      'SS2202', /*Galaxy S9+*/
      
      'SS2286', /*Galaxy Z Flip7*/
      'SS2257', /*Galaxy Z Flip6*/
      'SS2226', /*Galaxy Z Flip5*/
      'SS2287', /*Galaxy Z Fold7*/
      'SS2258', /*Galaxy Z Fold6*/
      'SS2227', /*Galaxy Z Fold5*/
      
      'SS2248', /*Galaxy A55*/
      'SS2216', /*Galaxy A54 5G*/
      'SS2175', /*Galaxy A53 5G*/
      'SS2203', /*Galaxy A52 5G*/
      'SS2164', /*Galaxy A32 5G*/
      'SS2271', /*Galaxy A25 5G*/
      'SS2192', /*Galaxy A23 5G*/
      
      'SS2193', /*Galaxy Buds Pro*/

    //Googleシリーズ
      'GG2288', /*Pixel 10*/
      'GG2289', /*Pixel 10 Pro*/
      'GG2290', /*Pixel 10 Pro XL*/
      'GG2270', /*Pixel 9a*/
      'GG2255', /*Pixel 9*/
      'GG2256', /*Pixel 9 Pro*/
      'GG2259', /*Pixel 9 Pro XL*/
      'GG2235', /*Pixel 8a*/
      'GG2218', /*Pixel 8*/
      'GG2219', /*Pixel 8 Pro*/
      'GG2213', /*Pixel 7a*/
      'GG2183', /*Pixel 7*/
      'GG2184', /*Pixel 7 Pro*/
      'GG2178', /*Pixel 6a*/
      'GG2132', /*Pixel 6*/
      'GG2133', /*Pixel 6 Pro*/
      'GG2120', /*Pixel 5*/
      'GG2138', /*Pixel 5a 5G*/

      'GG2260', /*Pixel Fold 2*/
      'GG2217', /*Pixel Fold*/

     //Xiaomiシリーズ
      'XM2275', /*Xiaomi 14T*/
      'XM2276', /*Xiaomi 14T Pro*/
      'XM2232', /*Xiaomi 13T*/
      'XM2233', /*Xiaomi 13T Pro*/
      'XM2210', /*Xiaomi 12T Pro*/
      'XM2136', /*Xiaomi 11T*/
      'XM2137', /*Xiaomi 11T Pro*/
      'XM2266', /*Xiaomi Redmi 12C*/
      'XM2140', /*Xiaomi Mi 11 Lite 5G*/
      
      'XM2249', /*Redmi Note 13 Pro 5G*/
      'XM2250', /*Redmi Note 13 Pro+ 5G*/
      'XM2189', /*Redmi Note 11*/
      'XM2190', /*Redmi Note 11 Pro*/
      'XM2122', /*Redmi Note 10 Pro*/
      'XM2169', /*Redmi Note10 JE*/
      'XM2231', /*Redmi 12 5G*/
      'XM2121', /*Redmi 9T*/

    //Xperiaシリーズ
      'SN2246', /*Xperia 1 VI*/
      'SN2214', /*Xperia 1 V*/
      'SN2165', /*Xperia 1 IV*/
      'SN2172', /*Xperia 1 III*/
      'SN2141', /*Xperia 1 II*/

      'SN2225', /*Xperia 5 V*/
      'SN2194', /*Xperia 5 IV*/
      'SN2151', /*Xperia 5 III*/
      'SN2123', /*Xperia 5 II*/
      'SN2142', /*Xperia 5*/

      'SN2247', /*Xperia 10 VI*/
      'SN2215', /*Xperia 10 V*/
      'SN2166', /*Xperia 10 IV*/
      'SN2125', /*Xperia 10 III*/
      'SN2143', /*Xperia 10 II*/

      'SN2167', /*Xperia Ace III*/

    //Motorolaシリーズ
      'MT2306', /*Motorola edge 60 pro*/
      'MT2265', /*Motorola edge 50 pro*/
      'MT2264', /*Motorola edge 40 neo*/
      'MT2263', /*Motorola edge 40*/
      'MT2186', /*Motorola edge 30 PRO*/
      'MT2139', /*Motorola edge 20*/

      'MT2305', /*Motorola razr 60*/

      'MT2116', /*Motorola moto g100*/
      'MT2129', /*Motorola moto g50 5G*/

      'MT2187', /*Motorola moto g31*/
      'MT2201', /*Motorola moto g30*/

    //OPPOシリーズ
      'OP2262', /*'OPPO Reno9 A*/
      'OP2188', /*'OPPO Reno7 A*/
      'OP2134', /*'OPPO A54 5G*/
      'OP2153', /*'OPPO A55s 5G*/
      'OP2163', /*'OPPO Find X3 Pro*/

    //AQUOSシリーズ
      'SH2285', /*AQUOS R10*/
      'SH2291', /*AQUOS R9*/
      'SH2292', /*AQUOS R9 Pro*/

      'SH2284', /*AQUOS wish5*/
      'SH2294', /*AQUOS wish4*/
      'SH2293', /*AQUOS wish3*/
      'SH2177', /*AQUOS wish2*/
      'SH2149', /*AQUOS wish*/

      'SH2310', /*AQUOS sense10*/
      'SH2296', /*AQUOS sense9*/
      'SH2295', /*AQUOS sense8*/
      'SH2185', /*AQUOS sense7*/
      'SH2165', /*AQUOS sense6s*/
      'SH2148', /*AQUOS sense6*/
      'SH2170', /*AQUOS sense5G*/
      'SH2171', /*AQUOS sense3 basic*/

      'SH2168', /*AQUOS zero6*/

    //HUAWEI
        'HW2117', /*HUAWEI P30 lite*/

    //arrowsシリーズ
      'FC2150', /*arrows We*/ 

    //ZTEシリーズ
      // ZT2234', /*Libero Flip*/
    ]
  }
];

// グロナビに表示する機種
window.fox.settings.models_displaying_global_nav = [
  //iPhone
    'AP2279', /*iPhone 17*/
    'AP2280', /*iPhone 17 Pro*/
    'AP2281', /*iPhone Air*/
    'AP2282', /*iPhone 17 Pro Max*/
    'AP2267', /*iPhone 16e*/
    'AP2251', /*iPhone 16*/
    'AP2252', /*iPhone 16 Pro*/
    'AP2253', /*iPhone 16 Plus*/
    'AP2254', /*iPhone 16 Pro Max*/
    'AP2221', /*iPhone 15*/
    'AP2223', /*iPhone 15 Pro*/
    'AP2222', /*iPhone 15 Plus*/
    'AP2224', /*iPhone 15 Pro Max*/
    'AP2179', /*iPhone 14*/
    'AP2181', /*iPhone 14 Pro*/
    'AP2180', /*iPhone 14 Plus*/
    'AP2182', /*iPhone 14 Pro Max*/
    'AP2111', /*iPhone 13*/
    'AP2112', /*iPhone 13 Pro*/
    'AP2110', /*iPhone 13 mini*/
    'AP2113', /*iPhone 13 Pro Max*/
    'AP2107', /*iPhone 12*/
    'AP2108', /*iPhone 12 Pro*/
    'AP2106', /*iPhone 12 mini*/
    'AP2109', /*iPhone 12 Pro Max*/
    'AP2145', /*iPhone SE 3rd Generation*/
    'AP2114', /*iPhone SE 2nd Generation*/
    'AP2105', /*iPhone 11*/
    'AP2144', /*iPhone 11 Pro*/
    'AP2200', /*iPhone 11 Pro Max*/
    'AP2104', /*iPhone XR*/
    'AP2131', /*iPhone XS*/
    'AP2199', /*iPhone XS Max*/
    'AP2130', /*iPhone X*/
    'AP2127', /*iPhone 8*/
    'AP2198', /*iPhone 8 Plus*/
    'AP2126', /*iPhone 7*/
    'AP2197', /*iPhone 7 Plus*/
    'AP2196', /*iPhone 6s Plus*/

  // Android
    'SS2268', /*Galaxy S25*/
    'SS2269', /*Galaxy S25 Ultra*/
    'GG2288', /*Pixel 10*/
];

// IDと名称のマップ(大分類・ケース)
window.fox.settings.h1case = {
  h1_HY: 'Hybrid Case',
  h1_SP: 'Slim Protection Case',
  h1_PC: 'LAVIE SOL着せ替えケース',
  h1_FL: 'Folio Case',
  h1_HYSL: 'Hybrid Case with Sling',
  h1_FLSL: 'Folio Case with Sling',
  h1_SPLR: 'リボン付きケース',
  h1_NKST: 'Slim Protection Case+スマホショルダー(細)(ロープ/長さ調整可能)',
  h1_HDST: 'Slim Protection Case+スマホハンドストラップ(細)(ロープ/長さ調整可能)',
  h1_BNKST: 'Slim Protection Case+スマホショルダー(太)(ロープ)',
  h1_AWCB: 'Apple Watch Clear Band',
  h1_SPLRBK: 'Slim Protection Case LANVIN en Bleu RIBBON Black',
  h1_SPLRSP: 'Slim Protection Case LANVIN en Bleu RIBBON Sakura Pink',
  h1_SPLRNV: 'Slim Protection Case LANVIN en Bleu RIBBON Navy',
  h1_SPLRCL: 'Slim Protection Case LANVIN en Bleu RIBBON Clear',
  h1_SPLRCY: 'Slim Protection Case LANVIN en Bleu RIBBON Cream Yellow',
  h1_SPLRSL: 'Slim Protection Case LANVIN en Bleu RIBBON Silver',
  h1_SPLRGD: 'Slim Protection Case LANVIN en Bleu RIBBON Gold',
  h1_RS: 'リング付き着せ替えシート',
  h1_RSBK: 'リング付きシート ブラック',
  h1_RSGD: 'リング付きシート ゴールド',
  h1_RSPU: 'リング付きシート パープル',
  h1_GB2: 'Galaxy Buds2',
  h1_GBP: 'Galaxy Buds Pro',
  h1_GB2P: 'Galaxy Buds2 Pro',
  h1_GWSB: 'Galaxy Watch4 シリコンバンド',
  h1_GF: 'ギフトラッピング袋',
  h1_GYPL: '着せ替えクリアプレート',
  h1_GYPELR: '着せ替えクリアプレート LANVIN en Bleu RIBBON',
  h1_CC: 'Clear Case',
  h1_SPSRBK: 'Slim Protection Case - STAND & RING RIBBON Black',
  h1_SPSRPK: 'Slim Protection Case - STAND & RING RIBBON Sakura Pink',
  h1_SPSRSL: 'Slim Protection Case - STAND & RING RIBBON Silver',
  h1_APS: 'ArtPanel Speaker',
  h1_APSPL: 'ArtPanel',
  h1_CW: 'MagSafe Card Wallet',
  h1_PW: 'Premium Card Wallet',
  h1_NKSTGYT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_NKSTBKGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]',
  h1_NKSTNVGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]',
  h1_BNKSTBKT: 'スマホショルダータグ(太)(ロープ) [ ブラック ]',
  h1_BNKSTBET: 'スマホショルダータグ(太)(ロープ) [ ベージュ ]',
  h1_BNKSTDPGYT: 'スマホショルダータグ(太)(ロープ) [ ディープグレー ]',
  h1_HDSTGYT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_HDSTBKGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]',
  h1_HDSTNVGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]',
  h1_AWLB: 'Apple Watch Leather Band',
  h1_SSTG: 'スマホショルダータグ',
  h1_SGSBK: 'スマートグリップスタンド [ Black ]',
  h1_SGSWH: 'スマートグリップスタンド [ White ]',
  h1_FR: 'Slim Protection Premium Case',
  h1_FM: 'Slim Protection Premium Case with MagSafe',
  h1_PN: 'Premium Panel',
  h1_FP: 'Premium Square Case with Pixelsnap',
  h1_FS: 'Premium Square Case with MagSafe',
};

window.fox.settings.h1case_casetype = [
  'h1_HYSL',
  'h1_FLSL',
  'h1_SPLR',
  'h1_NKST',
  'h1_HDST',
  'h1_BNKST',
  'h1_GB2',
  'h1_GBP',
  'h1_GB2P',
];

// IDと名称のマップ(大分類・アクセサリー)
window.fox.settings.h1accessory = {
  h1_SB: 'Sticking Battery',
  h1_PG: 'Screen Protector',
  h1_MB: 'MagSafe Mobile Battery',
  h1_AWCB: 'Apple Watch Clear Band',
  h1_AP: 'AirPods Case',
  h1_SR: 'Phone Ring',
  h1_NK: 'Smartphone shoulder strap (thin)',
  h1_HD: 'Smartphone hand strap (thin)',
  h1_BNK: 'Smartphone shoulder strap (thick)',
  h1_SHSTAP: 'Smartphone shoulder strap (thin) with AirPods Holder',
  h1_ST: 'Strap',
  h1_ST: 'Strap',
  h1_NKST: 'Slim Protection Case+スマホショルダー(細)(ロープ/長さ調整可能)',
  h1_HDST: 'Slim Protection Case+スマホハンドストラップ(細)(ロープ/長さ調整可能)',
  h1_BNKST: 'Slim Protection Case+スマホショルダー(太)(ロープ)',
  h1_SPLRBK: 'Slim Protection Case LANVIN en Bleu RIBBON Black',
  h1_SPLRPK: 'Slim Protection Case LANVIN en Bleu RIBBON Sakura Pink',
  h1_SPLRNV: 'Slim Protection Case LANVIN en Bleu RIBBON Navy',
  h1_SPLRCL: 'Slim Protection Case LANVIN en Bleu RIBBON Clear',
  h1_SPLRCY: 'Slim Protection Case LANVIN en Bleu RIBBON Cream Yellow',
  h1_SPLRSL: 'Slim Protection Case LANVIN en Bleu RIBBON Silver',
  h1_SPLRGD: 'Slim Protection Case LANVIN en Bleu RIBBON Gold',
  h1_GB2: 'Galaxy Buds2',
  h1_GBP: 'Galaxy Buds Pro',
  h1_GB2P: 'Galaxy Buds2 Pro',
  h1_RS: 'Galaxy Z Flip4 リング付き着せ替えシート',
  h1_GWSB: 'Galaxy Watch4 シリコンバンド',
  h1_GYPL: '着せ替えクリアプレート',
  h1_GYPELR: '着せ替えクリアプレート LANVIN en Bleu RIBBON',
  h1_CC: 'Clear Case',
  h1_SPSRBK: 'Slim Protection Case - STAND & RING RIBBON Black',
  h1_SPSRPK: 'Slim Protection Case - STAND & RING RIBBON Sakura Pink',
  h1_SPSRSL: 'Slim Protection Case - STAND & RING RIBBON Silver',
  h1_APS: 'ArtPanel Speaker',
  h1_APSPL: 'ArtPanel',
  h1_CW: 'MagSafe Card Wallet',
  h1_PW: 'Premium Card Wallet',
  h1_NKSTGYT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_NKSTBKGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]',
  h1_NKSTNVGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]',
  h1_BNKSTBKT: 'スマホショルダータグ(太)(ロープ) [ ブラック ]',
  h1_BNKSTBET: 'スマホショルダータグ(太)(ロープ) [ ベージュ ]',
  h1_BNKSTDPGYT: 'スマホショルダータグ(太)(ロープ) [ ディープグレー ]',
  h1_HDSTGYT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_HDSTBKGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]',
  h1_HDSTNVGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]',
  h1_AWLB: 'Apple Watch Leather Band',
  h1_SSTG: 'Smartphone shoulder strap tag',
  h1_SGSBK: 'Smart Grip Stand [ Black ]',
  h1_SGSWH: 'Smart Grip Stand [ White ]',
  h1_LGR2: 'Rhine Stone Camera Lens Protector(2 Lenses) ',
  h1_LGR3: 'Rhine Stone Camera Lens Protector(3 Lenses) ',
  h1_LG2: 'Lens Grass(2Lens) ',
  h1_LG3: 'Lens Grass(3Lens) ',
  h1_FR: 'Slim Protection Premium Case',
  h1_FM: 'Slim Protection Premium Case with MagSafe',
};

window.fox.settings.h1 = {
  ...window.fox.settings.h1case ,
  ...window.fox.settings.h1accessory,
};



// タグとケースタイプの説明を管理するオブジェクト
const caseTypeDescriptions = {
  // h1_HY: 'Hybrid Caseの説明テキスト',
  // h1_PC: 'LAVIE SOL着せ替えケースの説明テキスト',
  // h1_FL: 'Folio Caseの説明テキスト',
  // h1_HYSL: 'Hybrid Case with Slingの説明テキスト',
  // h1_FLSL: 'Folio Case with Slingの説明テキスト',
  // h1_SPLR: 'リボン付きケースの説明テキスト',
  // h1_NKST: 'スリムプロテクションケース+スマホショルダー(細)(ロープ/長さ調整可能)の説明テキスト',
  // h1_HDST: 'スリムプロテクションケース+スマホハンドストラップ(細)(ロープ/長さ調整可能)の説明テキスト',
  // h1_BNKST: 'スリムプロテクションケース+スマホショルダー(太)(ロープ)の説明テキスト',
  // h1_AWCB: 'Apple Watchクリアバンドの説明テキスト',
  // h1_SPLRBK: 'スリムプロテクションケース LANVIN en Bleu RIBBON Blackの説明テキスト',
  // h1_SPLRSP: 'スリムプロテクションケース LANVIN en Bleu RIBBON Sakura Pinkの説明テキスト',
  // h1_SPLRNV: 'スリムプロテクションケース LANVIN en Bleu RIBBON Navyの説明テキスト',
  // h1_SPLRCL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Clearの説明テキスト',
  // h1_SPLRCY: 'スリムプロテクションケース LANVIN en Bleu RIBBON Cream Yellowの説明テキスト',
  // h1_SPLRSL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Silverの説明テキスト',
  // h1_SPLRGD: 'スリムプロテクションケース LANVIN en Bleu RIBBON Goldの説明テキスト',
  // h1_RS: 'リング付き着せ替えシートの説明テキスト',
  // h1_RSBK: 'リング付きシート ブラックの説明テキスト',
  // h1_RSGD: 'リング付きシート ゴールドの説明テキスト',
  // h1_RSPU: 'リング付きシート パープルの説明テキスト',
  // h1_GB2: 'Galaxy Buds2の説明テキスト',
  // h1_GBP: 'Galaxy Buds Proの説明テキスト',
  // h1_GB2P: 'Galaxy Buds2 Proの説明テキスト',
  // h1_GWSB: 'Galaxy Watch4 シリコンバンドの説明テキスト',
  // h1_GF: 'ギフトラッピング袋の説明テキスト',
  // h1_GYPL: '着せ替えクリアプレートの説明テキスト',
  // h1_GYPELR: '着せ替えクリアプレート LANVIN en Bleu RIBBONの説明テキスト',
  // h1_CC: 'クリアケースの説明テキスト',
  // h1_SPSRBK: 'スリムプロテクションケース - STAND & RING RIBBON Blackの説明テキスト',
  // h1_SPSRPK: 'スリムプロテクションケース - STAND & RING RIBBON Sakura Pinkの説明テキスト',
  // h1_SPSRSL: 'スリムプロテクションケース - STAND & RING RIBBON Silverの説明テキスト',
  // h1_APS: 'アートパネルスピーカーの説明テキスト',
  // h1_APSPL: 'アートパネルの説明テキスト',
  // h1_CW: 'MagSafe対応カードウォレットの説明テキスト',
  // h1_NKSTGYT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ グレー ]の説明テキスト',
  // h1_NKSTBKGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]の説明テキスト',
  // h1_NKSTNVGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]の説明テキスト',
  // h1_BNKSTBKT: 'スマホショルダータグ(太)(ロープ) [ ブラック ]の説明テキスト',
  // h1_BNKSTBET: 'スマホショルダータグ(太)(ロープ) [ ベージュ ]の説明テキスト',
  // h1_BNKSTDPGYT: 'スマホショルダータグ(太)(ロープ) [ ディープグレー ]の説明テキスト',
  // h1_HDSTGYT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ グレー ]の説明テキスト',
  // h1_HDSTBKGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]の説明テキスト',
  // h1_HDSTNVGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]の説明テキスト',
  // h1_AWLB: 'Apple Watchレザーバンドの説明テキスト',
  // h1_SSTG: 'スマホショルダータグの説明テキスト',
  // h1_SGSBK: 'スマートグリップスタンド [ Black ]の説明テキスト',
  // h1_SGSWH: 'スマートグリップスタンド [ White ]の説明テキスト',
  // h1_PC: 'LAVIE SOL着せ替えケースの説明テキスト',
  h1_SP: '<b>1.2m</b><br>Shock-proof<br><br><br>Textured<br><b>Front printing</b><br><br><br>Magsafe<br><b>Not compatible</b>',
  h1_FR: '<b>3.6m</b><br>Shock-proof<br><br>Beautiful color reproduction<br><b>Rear printing</b><br><br>Magsafe<br><b>Not compatible</b>',
  h1_FM: '<b>3.6m</b><br>Shock-proof<br><br>Beautiful color reproduction<br><b>Rear printing</b><br><br>Magsafe<br><b>Not compatible</b>',
  h1_FM_black_ring: '<b>3.6m</b><br>Shock-proof<br><br>Beautiful color reproduction<br><b>Rear printing</b><br><br>Magsafe<br><b>Not compatible</b>',
};





// IDと名称のマップ(ケース素材)（検索UIでは使用していない）
window.fox.settings.material = {
  m_RP: '再生プラスチック',
  m_GL: 'Glass',
  m_SP: '確認中',
  m_NKSTGY: 'ポリエステル',
  m_NKSTBKGD: 'ポリエステル',
  m_NKSTNVGD: 'ポリエステル',
  m_HDSTGY: 'ポリエステル',
  m_HDSTBKGD: 'ポリエステル',
  m_HDSTNVGD: 'ポリエステル',
  m_BNKSTORPUBL: 'ポリエステル',
  m_BNKSTORPUDP: 'ポリエステル',
  m_BNKSTORPI: 'ポリエステル',
  m_SHSTAPBK: 'ポリエステル',
  m_SHSTAPPK: 'ポリエステル',
  m_PC: 'プラスチック',
  m_TPU: 'TPU',
  m_APTPU: 'TPU',
  m_AWCBTPU: 'TPU',
  m_LRBK: 'ヴィーガンレザー',
  m_LRCL: 'ヴィーガンレザー',
  m_LRCY: 'ヴィーガンレザー',
  m_LRGD: 'ヴィーガンレザー',
  m_LRNV: 'ヴィーガンレザー',
  m_LRPK: 'ヴィーガンレザー',
  m_LRSL: 'ヴィーガンレザー',
  m_RSCLBK: 'リング付き着せ替えシート クリアブラック',
  m_RSCL: 'リング付き着せ替えシート クリア',
  m_RSBK: 'リング付きシート ブラック',
  m_RSGD: 'リング付きシート ゴールド',
  m_RSPU: 'リング付きシート パープル',
  m_GBP: 'TPU',
  m_GB2P: 'TPU',
  m_GWCBWH: 'シリコン',
  m_GWCBPP: 'シリコン',
  m_GWCBPG: 'シリコン',
  m_CC: 'ポリカーボネート',
  m_SRRBK: 'ヴィーガンレザー',
  m_SRRPK: 'ヴィーガンレザー',
  m_SRRSL: 'ヴィーガンレザー',
  m_APSABS: 'ABS',
  m_APSPLABS: 'ABS',
  m_CWVL: 'ヴィーガンレザー',
  m_NKSTGYT: 'スマホショルダータグ',
  m_NKSTBKGDT: 'スマホショルダータグ',
  m_NKSTNVGDT: 'スマホショルダータグ',
  m_BNKSTBKT: 'スマホショルダータグ',
  m_BNKSTBET: 'スマホショルダータグ',
  m_BNKSTDPGYT: 'スマホショルダータグ',
  m_HDSTGYT: 'スマホショルダータグ',
  m_HDSTBKGDT: 'スマホショルダータグ',
  m_HDSTNVGDT: 'スマホショルダータグ',
  m_AWLBVL: 'ヴィーガンレザー',
  m_SSTGTPU: 'TPU',
  m_SGSBKPC: 'プラスチック',
  m_SGSWHPC: 'プラスチック',
  m_FT: 'Clear Flame',
  m_FB: 'ClearBlack Flame',
  m_CL: 'ClearBase',
  m_CB: 'ClearBlack Flame',
};

// カラー名称とカラーコードのマップ（現状存在だけで使用していない）
window.fox.settings.color = {
  'cl_RED': '#E50303',
  'cl_YELLOW': '#ffc200',
  'cl_ORANGE': '#ff8e00',
  'cl_GREEN': '#42c000',
  'cl_GRAY': '#9d9a9b',
  'cl_NAVY': '#1f0d61',
  'cl_PURPLE': '#8e00ff',
  'cl_PINK': '#ff69db',
  'cl_BROWN': '#ba8245',
  'cl_BLACK': '#000',
  'cl_BLUE': '#0000ff',
  'cl_BEIGE': '#D1B48A',
  'cl_WHITE': '#fff',
  'cl_MULTICOLOR': '#fff',
  'cl_LIGHTBLUE': '#7eb5d1',
};

// デフォルト機種（Apple iPhone X）
window.fox.settings.default_model = 'AP2130';
const ACCESSORY_QUERY_MODEL = "model";
const ACCESSORY_QUERY_DESIGN = "design";

window.fox.settings.buyTogetherAccessoryList = [
  {
    tag: 'h1_PG',
    query: ACCESSORY_QUERY_MODEL,
  },
  {
    tag: 'h1_SB',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_MB',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_AP',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_SR',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_ST',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_NK',
    query: ACCESSORY_QUERY_DESIGN,
  }
];


// ここにモデルデータを追加
window.fox.settings.model_groupss = [
  {
    label: 'iPhoneシリーズ',
    code: 'AP',
    code_sort: [
      'AP2279', /*iPhone 17*/
      'AP2280', /*iPhone 17 Pro*/
      'AP2281', /*iPhone Air*/
      'AP2282', /*iPhone 17 Pro Max*/
      'AP2267', /*iPhone 16e*/
      'AP2251', /*iPhone 16*/
      'AP2252', /*iPhone 16 Pro*/
      'AP2253', /*iPhone 16 Plus*/
      'AP2254', /*iPhone 16 Pro Max*/
      'AP2221', /*iPhone 15*/
      'AP2223', /*iPhone 15 Pro*/
      'AP2222', /*iPhone 15 Plus*/
      'AP2224', /*iPhone 15 Pro Max*/
      'AP2179', /*iPhone 14*/
      'AP2181', /*iPhone 14 Pro*/
      'AP2180', /*iPhone 14 Plus*/
      'AP2182', /*iPhone 14 Pro Max*/
      'AP2111', /*iPhone 13*/
      'AP2112', /*iPhone 13 Pro*/
      'AP2110', /*iPhone 13 mini*/
      'AP2113', /*iPhone 13 Pro Max*/
      'AP2107', /*iPhone 12*/
      'AP2108', /*iPhone 12 Pro*/
      'AP2106', /*iPhone 12 mini*/
      'AP2109', /*iPhone 12 Pro Max*/
      'AP2145', /*iPhone SE 3rd Generation*/
      'AP2114', /*iPhone SE 2nd Generation*/
      'AP2105', /*iPhone 11*/
      'AP2144', /*iPhone 11 Pro*/
      'AP2200', /*iPhone 11 Pro Max*/
      'AP2104', /*iPhone XR*/
      'AP2131', /*iPhone XS*/
      'AP2199', /*iPhone XS Max*/
      'AP2130', /*iPhone X*/
      'AP2127', /*iPhone 8*/
      'AP2198', /*iPhone 8 Plus*/
      'AP2126', /*iPhone 7*/
      'AP2197', /*iPhone 7 Plus*/
      'AP2196' /*iPhone 6s Plus*/
    ]
  },
  {
    label: 'Galaxyシリーズ',
    code: 'SS',
    code_sort: [
      'SS2268', /*Galaxy S25*/
      'SS2269', /*Galaxy S25 Ultra*/
      'SS2238', /*Galaxy S24*/
      'SS2239', /*Galaxy S24 Ultra*/
      'SS2237', /*Galaxy S23 FE*/
      'SS2211', /*Galaxy S23*/
      'SS2212', /*Galaxy S23 Ultra*/
      'SS2147', /*Galaxy S22*/
      'SS2161', /*Galaxy S22 Ultra*/
      'SS2103', /*Galaxy S21 5G*/
      'SS2162', /*Galaxy S21+ 5G*/
      'SS2207', /*Galaxy S21 Ultra 5G*/
      'SS2135', /*Galaxy S20*/
      'SS2205', /*Galaxy S20+*/
      'SS2206', /*Galaxy S20 Ultra*/
      'SS2146', /*Galaxy S10*/
      'SS2204', /*Galaxy S10+*/
      'SS2209', /*Galaxy S9*/
      'SS2202', /*Galaxy S9+*/
      
      'SS2286', /*Galaxy Z Flip7*/
      'SS2257', /*Galaxy Z Flip6*/
      'SS2226', /*Galaxy Z Flip5*/
      'SS2287', /*Galaxy Z Fold7*/
      'SS2258', /*Galaxy Z Fold6*/
      'SS2227', /*Galaxy Z Fold5*/
      
      'SS2248', /*Galaxy A55*/
      'SS2216', /*Galaxy A54 5G*/
      'SS2175', /*Galaxy A53 5G*/
      'SS2203', /*Galaxy A52 5G*/
      'SS2164', /*Galaxy A32 5G*/
      'SS2271', /*Galaxy A25 5G*/
      'SS2192', /*Galaxy A23 5G*/
      
      'SS2193' /*Galaxy Buds Pro*/
    ]
  },
  {
    label: 'Googleシリーズ',
    code: 'GG',
    code_sort: [
      'GG2288', /*Pixel 10*/
      'GG2289', /*Pixel 10 Pro*/
      'GG2290', /*Pixel 10 Pro XL*/
      'GG2270', /*Pixel 9a*/
      'GG2255', /*Pixel 9*/
      'GG2256', /*Pixel 9 Pro*/
      'GG2259', /*Pixel 9 Pro XL*/
      'GG2235', /*Pixel 8a*/
      'GG2218', /*Pixel 8*/
      'GG2219', /*Pixel 8 Pro*/
      'GG2213', /*Pixel 7a*/
      'GG2183', /*Pixel 7*/
      'GG2184', /*Pixel 7 Pro*/
      'GG2178', /*Pixel 6a*/
      'GG2132', /*Pixel 6*/
      'GG2133', /*Pixel 6 Pro*/
      'GG2120', /*Pixel 5*/
      'GG2138', /*Pixel 5a 5G*/

      'GG2260', /*Pixel Fold 2*/
      'GG2217' /*Pixel Fold*/
    ]
  },
  {
    label: 'Xiaomiシリーズ',
    code: 'XM',
    code_sort: [
      'XM2275', /*Xiaomi 14T*/
      'XM2276', /*Xiaomi 14T Pro*/
      'XM2232', /*Xiaomi 13T*/
      'XM2233', /*Xiaomi 13T Pro*/
      'XM2210', /*Xiaomi 12T Pro*/
      'XM2136', /*Xiaomi 11T*/
      'XM2137', /*Xiaomi 11T Pro*/
      'XM2266', /*Xiaomi Redmi 12C*/
      'XM2140', /*Xiaomi Mi 11 Lite 5G*/
      
      'XM2249', /*Redmi Note 13 Pro 5G*/
      'XM2250', /*Redmi Note 13 Pro+ 5G*/
      'XM2189', /*Redmi Note 11*/
      'XM2190', /*Redmi Note 11 Pro*/
      'XM2122', /*Redmi Note 10 Pro*/
      'XM2169', /*Redmi Note10 JE*/
      'XM2231', /*Redmi 12 5G*/
      'XM2121' /*Redmi 9T*/
    ]
  },
  {
    label: 'Xperiaシリーズ',
    code: 'SN',
    code_sort: [
      'SN2246', /*Xperia 1 VI*/
      'SN2214', /*Xperia 1 V*/
      'SN2165', /*Xperia 1 IV*/
      'SN2172', /*Xperia 1 III*/
      'SN2141', /*Xperia 1 II*/

      'SN2225', /*Xperia 5 V*/
      'SN2194', /*Xperia 5 IV*/
      'SN2151', /*Xperia 5 III*/
      'SN2123', /*Xperia 5 II*/
      'SN2142', /*Xperia 5*/

      'SN2247', /*Xperia 10 VI*/
      'SN2215', /*Xperia 10 V*/
      'SN2166', /*Xperia 10 IV*/
      'SN2125', /*Xperia 10 III*/
      'SN2143', /*Xperia 10 II*/

      'SN2167' /*Xperia Ace III*/
    ]
  },
  {
    label: 'Motorolaシリーズ',
    code: 'MT',
    code_sort: [
      'MT2306', /*Motorola edge 60 pro*/
      'MT2265', /*Motorola edge 50 pro*/
      'MT2264', /*Motorola edge 40 neo*/
      'MT2263', /*Motorola edge 40*/
      'MT2186', /*Motorola edge 30 PRO*/
      'MT2139', /*Motorola edge 20*/

      'MT2305', /*Motorola razr 60*/

      'MT2116', /*Motorola moto g100*/
      'MT2129', /*Motorola moto g50 5G*/

      'MT2187', /*Motorola moto g31*/
      'MT2201' /*Motorola moto g30*/
    ]
  },
  {
    label: 'OPPOシリーズ',
    code: 'OP',
    code_sort: [
      'OP2262', /*'OPPO Reno9 A*/
      'OP2188', /*'OPPO Reno7 A*/
      'OP2134', /*'OPPO A54 5G*/
      'OP2153', /*'OPPO A55s 5G*/
      'OP2163' /*'OPPO Find X3 Pro*/
    ]
  },
  {
    label: 'AQUOSシリーズ',
    code: 'SH',
    code_sort: [
      'SH2285', /*AQUOS R10*/
      'SH2291', /*AQUOS R9*/
      'SH2292', /*AQUOS R9 Pro*/

      'SH2284', /*AQUOS wish5*/
      'SH2294', /*AQUOS wish4*/
      'SH2293', /*AQUOS wish3*/
      'SH2177', /*AQUOS wish2*/
      'SH2149', /*AQUOS wish*/

      'SH2310', /*AQUOS sense10*/
      'SH2296', /*AQUOS sense9*/
      'SH2295', /*AQUOS sense8*/
      'SH2185', /*AQUOS sense7*/
      'SH2165', /*AQUOS sense6s*/
      'SH2148', /*AQUOS sense6*/
      'SH2170', /*AQUOS sense5G*/
      'SH2171', /*AQUOS sense3 basic*/

      'SH2168', /*AQUOS zero6*/
    ]
  },
  {
    label: 'HUAWEIシリーズ',
    code: 'HW',
    code_sort: [
        'HW2117' /*HUAWEI P30 lite*/
    ]
  },
  {
    label: 'arrowsシリーズ',
    code: 'FC',
    code_sort: [
        'FC2150' /*arrows We*/
    ]
  }
  
  // ,
  //  {
  //   label: 'ZTEシリーズ',
  //   code: 'ZT',
  //   code_sort: [
  //     'ZT2234' /*Libero Flip*/
  //   ]
  //  }
];

